module.exports = __webpack_public_path__ + "static/media/Arge_Weilheim.10d2e345.pdf";